/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "28bf12d451b2106da1d937479160a636051818da";
